import { writable } from "svelte/store";
import type { MenuItem } from "../../../core/schema/MenuItem.js";

/**
 * A store that keeps track of active menu item, with submenus.
 */
export const activeSubmenu = writable<MenuItem | null>(null);
